module.exports = __webpack_public_path__ + "img/mechanic-icon.e7626a29.svg";